import React from "react";
import {Button, Label, Flag, Modal} from "semantic-ui-react";
import PromtFormatter from "../reactQuill/PromtFormatter";
import {extractJSONFromResponse} from "./ModalTextArea";
import ReactQuill from "react-quill";
import TranslateIconButton from "./TranslateIconButton";
interface PreviewScreenProps {
    value: any;
    apiResult: any;
    loading: boolean;
    error: string | null;
    reviewChecked: boolean;
    handleRequestPreview?: () => void;
    handleSuggestionPreview?: () => void;
    onBack: () => void;
    onConfirm: (previewText: string) => void;
    onCheckReview: (checked: boolean) => void;
    previewDialogHeaders?: {
            dialogheader?: string;
            subHeader?: string;
            originalLabel?: string;
            previewLabel?: string;
            confirmLabel?: string;
            cancelLabel?: string;
            confirmChangeLabel?: string;
            grammarSubHeader?:string;
            generateSubHeader?:string;
        };

    isNewGrid?: boolean;
    grammarKey?: string | null;
    generateSuggestion?: boolean;
}

const PreviewScreen: React.FC<PreviewScreenProps> = ({
    value,
    apiResult,
    loading,
    error,
    onBack,
    onConfirm,
    isNewGrid,
    previewDialogHeaders,
    grammarKey,
    generateSuggestion
}) => {
    const {
        dialogheader =undefined,
        subHeader=undefined,
        originalLabel=undefined,
        previewLabel=undefined,
        confirmLabel=undefined,
        cancelLabel = undefined,
        confirmChangeLabel = undefined,
        grammarSubHeader = undefined,
        generateSubHeader = undefined
    } = previewDialogHeaders || {};
    let previewText = '';

    const rawData = (apiResult && apiResult.text)
        ? apiResult.text
        : (typeof apiResult === 'string' ? apiResult : '');
    previewText = extractJSONFromResponse(rawData);

    if (typeof previewText === 'string') {
        previewText = previewText.trim();
        if (previewText.startsWith('"') && previewText.endsWith('"')) {
            previewText = previewText.slice(1, -1);
        }
    }

    const isGrammarMode = !!grammarKey;
    const renderItems = () => {
        const deItem = value ? Object.keys(value).map(key => value[key]).find((v: any) => v.flag === "de") : null;
        const originalFlag = isGrammarMode ? (value[grammarKey!] && value[grammarKey!].flag || "de") : "de";
        const previewFlag = (isGrammarMode || generateSuggestion) ? originalFlag : "gb";

        return (
            <div className="modal-text-area-tile full-width" style={{ width: '100%' }}>
                <div className="modal-text-area-header" style={{ gap: '15px', padding:'unset', marginBottom:'5px' }}>
                    <Label basic={true} className="flag-label">
                        <Flag name={originalFlag} />
                        <span style={{ fontWeight: 600 }}>{originalLabel}</span>
                    </Label>
                    <Label basic={true} className="flag-label">
                        <Flag name={previewFlag} />
                        <span style={{ fontWeight: 600}}>{previewLabel}</span>
                    </Label>
                </div>
                <div className="preview-dual-pane">
                    <div className="preview-pane">
                        <div className="preview-box-border">
                            <PromtFormatter
                                className="no-border-quill"
                                value={isGrammarMode ? (value[grammarKey!] && value[grammarKey!].value || "") : (deItem && deItem.value || "")}
                            />
                        </div>
                    </div>
                    <div className="preview-pane">
                        <div className="preview-box-border">
                            <ReactQuill value={previewText} readOnly={true} theme="bubble" />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal.Content className="modal-text-area-content" style={{height: isNewGrid ? "100%" : "80%", position: "relative"}}>

            <div className="modal-preview-grid" role="region" aria-label="Preview changes">
                {/* Left help/hint column */}
                <div className="modal-preview-hint">
                    <div style={{fontWeight: 600, marginBottom: 8}}>{dialogheader}</div>
                    <div>{isGrammarMode ? grammarSubHeader : (generateSuggestion ?
                         generateSubHeader : subHeader)}</div>
                </div>

                {/* Center: Original and Preview panes (side-by-side) */}
                <div className="modal-preview-center" style={{ width: '100%' }} aria-live="polite">
                    {renderItems()}
                </div>

                {/* Right: Checkbox / controls */}
                <div style={{width: '100%'}}>
                    <div style={{display: 'flex', gap: '20px', justifyContent: 'flex-end'}}>
                        <Button onClick={onBack} disabled={loading}>
                            {cancelLabel}
                        </Button>
                        <Button
                            positive={true}
                            onClick={() => onConfirm(previewText)}
                            content={loading ? confirmChangeLabel :confirmLabel}
                        />
                    </div>
                </div>

            </div>
            {error && (
                <div role="alert" style={{color: "crimson", marginTop: 10}}>
                    {error}
                </div>
            )}
        </Modal.Content>
    );
};

export default PreviewScreen;



// WEBPACK FOOTER //
// ./src/components/Table/components/twoLanguage/PreviewScreen.tsx